export enum PRODUCT {
  ASK_X = 'Ask X',
  CLAUDE_MCP_CONNECTOR = 'Claude MCP Connector',
  COPY_PROJECT_TO_ANOTHER_ACCOUNT = 'Copy project to another account',
  CRUNCHBASE = 'Crunchbase',
  ENHANCE_PROJECT = 'Enhance project',
  EXPLORE = 'Explore',
  EXPORT_STREAM = 'Export stream',
  EXPORT_TO_PPT = 'Export project to ppt',
  EXTENDED_COPY_PROJECT_TO_ANOTHER_ACCOUNT = 'Extended copy project to another account',
  KPI_ORGANIZATION_VERIFIED_LIST = 'View KPI organization verified list',
  SPOTLIGHT = 'Spotlight',
  TEAM_CONTACTS = 'Team contacts',
  VERIFY_COMPANY = 'Verify company',
  PERSONAL_ACCESS_TOKEN = 'Personal Access Token',
}
